module.exports = __webpack_public_path__ + "static/media/01dec1918.7dbcbb90.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/01dec1918.png
// module id = 248
// module chunks = 0